module.exports = __webpack_public_path__ + "img/brand1.701ac13e.png";